import React from 'react';

export interface ReceivedLastCellProps {
    date: string;
    qty: string | number;
}

const ReceivedLastCell: React.FC<ReceivedLastCellProps> = ({ date, qty }) => {
    if (!date) return null;
    return (
        <div style={{ lineHeight: '1.2' }}>
            <div>{date}</div>
            <div>({qty})</div>
        </div>
    );
};

export default React.memo(ReceivedLastCell);
